import React from 'react';

const Col = ({ width }) => <col style={{ width }} />;

export default Col;



// WEBPACK FOOTER //
// ./src/components/Col.js